export default __webpack_public_path__ + "static/media/shape-57.2e1d6fc3.png";